'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _zipObject = _interopDefault(require('lodash/zipObject'));
var _isNaN = _interopDefault(require('lodash/isNaN'));
var _includes = _interopDefault(require('lodash/includes'));

var UNITED_STATES_REGION_ID = 102001;
var CANADA_REGION_ID = 404363;

var STATE_REGION_IDS = [UNITED_STATES_REGION_ID, // included for convenience
3, // AK
4, // AL
6, // AR
7, // AS
8, // AZ
9, // CA
10, // CO
11, // CT
13, // DE
14, // FL
16, // GA
17, // GU
18, // HI
19, // IA
20, // ID
21, // IL
22, // IN
23, // KS
24, // KY
25, // LA
26, // MA
27, // MD
28, // ME
30, // MI
31, // MN
32, // MO
33, // MP
34, // MS
35, // MT
36, // NC
37, // ND
38, // NE
39, // NH
40, // NJ
41, // NM
42, // NV
43, // NY
44, // OH
45, // OK
46, // OR
47, // PA
48, // PR
50, // RI
51, // SC
52, // SD
53, // TN
54, // TX
55, // UT
56, // VA
57, // VI
58, // VT
59, // WA
12, // DC
60, // WI
61, // WV
62];

var CANADA_STATE_REGION_IDS = [CANADA_REGION_ID, 404364, // AB
404365, // BC
404366, // MB
404367, // NT
404368, // NU
404369, // SK
404370, // NB
404371, // NS
404372, // NL
404373, // PE
404374, // QC
404375, // ON
404376];

var STATE_ABBREVIATIONS = ['US', // United States value included for convenience
'AK', 'AL', 'AR', 'AS', 'AZ', 'CA', 'CO', 'CT', 'DE', 'FL', 'GA', 'GU', 'HI', 'IA', 'ID', 'IL', 'IN', 'KS', 'KY', 'LA', 'MA', 'MD', 'ME', 'MI', 'MN', 'MO', 'MP', 'MS', 'MT', 'NC', 'ND', 'NE', 'NH', 'NJ', 'NM', 'NV', 'NY', 'OH', 'OK', 'OR', 'PA', 'PR', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT', 'VA', 'VI', 'VT', 'WA', 'DC', 'WI', 'WV', 'WY'];

var CANADA_STATE_ABBREVIATIONS = ['CAN', 'AB', 'BC', 'MB', 'NT', 'NU', 'SK', 'NB', 'NS', 'NL', 'PE', 'QC', 'ON', 'YT'];

// public since the SEO module needs to access these values
var STATE_FULL_NAMES = ['United States', // included for convenience
'Alaska', 'Alabama', 'Arkansas', 'American Samoa', 'Arizona', 'California', 'Colorado', 'Connecticut', 'Delaware', 'Florida', 'Georgia', 'Guam', 'Hawaii', 'Iowa', 'Idaho', 'Illinois', 'Indiana', 'Kansas', 'Kentucky', 'Louisiana', 'Massachusetts', 'Maryland', 'Maine', 'Michigan', 'Minnesota', 'Missouri', 'Northern Mariana Islands', 'Mississippi', 'Montana', 'North Carolina', 'North Dakota', 'Nebraska', 'New Hampshire', 'New Jersey', 'New Mexico', 'Nevada', 'New York', 'Ohio', 'Oklahoma', 'Oregon', 'Pennsylvania', 'Puerto Rico', 'Rhode Island', 'South Carolina', 'South Dakota', 'Tennessee', 'Texas', 'Utah', 'Virginia', 'Virgin Islands', 'Vermont', 'Washington', 'Washington, DC', 'Wisconsin', 'West Virginia', 'Wyoming'];

var CANADA_STATE_FULL_NAMES = ['Canada', 'Alberta', // AB
'British Columbia', // BC
'Manitoba', // MB
'Northwest Territories', // NT
'Nunavut', // NU
'Saskatchewan', // SK
'New Brunswick', // NB
'Nova Scotia', // NS
'Newfoundland and Labrador', // NL
'Prince Edward Island', // PE
'Quebec', // QC
'Ontario', // ON
'Yukon'];

var URL_STATE_FULL_NAMES = ['United_States', // included for convenience
'Alaska', 'Alabama', 'Arkansas', 'American_Samoa', 'Arizona', 'California', 'Colorado', 'Connecticut', 'Delaware', 'Florida', 'Georgia', 'Guam', 'Hawaii', 'Iowa', 'Idaho', 'Illinois', 'Indiana', 'Kansas', 'Kentucky', 'Louisiana', 'Massachusetts', 'Maryland', 'Maine', 'Michigan', 'Minnesota', 'Missouri', 'Northern_Mariana_Islands', 'Mississippi', 'Montana', 'North_Carolina', 'North_Dakota', 'Nebraska', 'New_Hampshire', 'New_Jersey', 'New_Mexico', 'Nevada', 'New_York', 'Ohio', 'Oklahoma', 'Oregon', 'Pennsylvania', 'Puerto_Rico', 'Rhode_Island', 'South_Carolina', 'South_Dakota', 'Tennessee', 'Texas', 'Utah', 'Virginia', 'Virgin_Islands', 'Vermont', 'Washington', 'Washington_DC', 'Wisconsin', 'West_Virginia', 'Wyoming'];

var CANADA_URL_STATE_FULL_NAMES = ['Canada', 'Alberta', // AB
'British_Columbia', // BC
'Manitoba', // MB
'Northwest_Territories', // NT
'Nunavut', // NU
'Saskatchewan', // SK
'New_Brunswick', // NB
'Nova_Scotia', // NS
'Newfoundland_and_Labrador', // NL
'Prince_Edward_Island', // PE
'Quebec', // QC
'Ontario', // ON
'Yukon'];

var ABBREVIATIONS_TO_REGION_IDS = _zipObject([].concat(STATE_ABBREVIATIONS, CANADA_STATE_ABBREVIATIONS), [].concat(STATE_REGION_IDS, CANADA_STATE_REGION_IDS));
var FULL_NAMES_TO_REGION_IDS = _zipObject([].concat(STATE_FULL_NAMES, CANADA_STATE_FULL_NAMES), [].concat(STATE_REGION_IDS, CANADA_STATE_REGION_IDS));
var URL_FULL_NAMES_TO_REGION_IDS = _zipObject([].concat(URL_STATE_FULL_NAMES, CANADA_URL_STATE_FULL_NAMES), [].concat(STATE_REGION_IDS, CANADA_STATE_REGION_IDS));
var REGION_IDS_TO_FULL_NAMES = _zipObject([].concat(STATE_REGION_IDS, CANADA_STATE_REGION_IDS), [].concat(STATE_FULL_NAMES, CANADA_STATE_FULL_NAMES));
var REGION_IDS_TO_URL_FULL_NAMES = _zipObject([].concat(STATE_REGION_IDS, CANADA_STATE_REGION_IDS), [].concat(URL_STATE_FULL_NAMES, CANADA_URL_STATE_FULL_NAMES));
var REGION_IDS_TO_ABBREVIATIONS = _zipObject([].concat(STATE_REGION_IDS, CANADA_STATE_REGION_IDS), [].concat(STATE_ABBREVIATIONS, CANADA_STATE_ABBREVIATIONS));
var ABBREVIATIONS_TO_FULL_NAMES = _zipObject([].concat(STATE_ABBREVIATIONS, CANADA_STATE_ABBREVIATIONS), [].concat(STATE_FULL_NAMES, CANADA_STATE_FULL_NAMES));

/**
 * This returns the corresponding regionId from the state abbreviation
 * @param stateAbbr the state abbreviation
 * @return the regionId
 */
function getRegionIdFromStateAbbr(stateAbbr) {
    return ABBREVIATIONS_TO_REGION_IDS[stateAbbr];
}

/**
 * This returns the corresponding regionId from the state full name
 * @param fullName the state full name
 * @return the regionId
 */
function getRegionIdFromFullName(fullName) {
    return FULL_NAMES_TO_REGION_IDS[fullName];
}

/**
 * This returns the corresponding regionId from the state url full name
 * @param urlFullName the state url full name
 * @return the regionId
 */
function getRegionIdFromUrlFullName(urlFullName) {
    return URL_FULL_NAMES_TO_REGION_IDS[urlFullName];
}

/**
 * This returns the state full name from the regionId
 * @param regionId the regionId
 * @return the state full name
 */
function getFullNameFromRegionId(regionId) {
    return REGION_IDS_TO_FULL_NAMES[regionId];
}

/**
 * This returns the state full name from the state abbreviation
 * @param stateAbbr the state abbreviation
 * @return the state full name
 */
function getFullNameFromAbbr(stateAbbr) {
    return ABBREVIATIONS_TO_FULL_NAMES[stateAbbr];
}

/**
 * This returns the state full url name from the regionId
 * @param regionId the regionId
 * @return the state full url name
 */
function getUrlFullNameFromRegionId(regionId) {
    return REGION_IDS_TO_URL_FULL_NAMES[regionId];
}

/**
 * This returns the state abbreviation from the regionId
 * @param regionId the regionId
 * @return the state abbreviation
 */
function getAbbrFromRegionId(regionId) {
    return REGION_IDS_TO_ABBREVIATIONS[regionId];
}

/**
 * This returns if the region belongs to Canada from the regionId
 * @param regionInfo either regionId or abbr or fullName
 * @return if the region belongs to Canada
 */
function isCanadian(regionInfo) {
    if (regionInfo) {
        var regionId = parseInt(regionInfo, 10);

        if (_isNaN(regionId)) {
            regionId = getRegionIdFromStateAbbr(regionInfo) || getRegionIdFromFullName(regionInfo);
        }

        if (!_isNaN(regionId) && typeof regionId === 'number') {
            return _includes(CANADA_STATE_REGION_IDS, regionId);
        }
    }

    return false;
}

exports.ABBREVIATIONS_TO_REGION_IDS = ABBREVIATIONS_TO_REGION_IDS;
exports.FULL_NAMES_TO_REGION_IDS = FULL_NAMES_TO_REGION_IDS;
exports.URL_FULL_NAMES_TO_REGION_IDS = URL_FULL_NAMES_TO_REGION_IDS;
exports.REGION_IDS_TO_FULL_NAMES = REGION_IDS_TO_FULL_NAMES;
exports.REGION_IDS_TO_URL_FULL_NAMES = REGION_IDS_TO_URL_FULL_NAMES;
exports.REGION_IDS_TO_ABBREVIATIONS = REGION_IDS_TO_ABBREVIATIONS;
exports.ABBREVIATIONS_TO_FULL_NAMES = ABBREVIATIONS_TO_FULL_NAMES;
exports.getRegionIdFromStateAbbr = getRegionIdFromStateAbbr;
exports.getRegionIdFromFullName = getRegionIdFromFullName;
exports.getRegionIdFromUrlFullName = getRegionIdFromUrlFullName;
exports.getFullNameFromRegionId = getFullNameFromRegionId;
exports.getFullNameFromAbbr = getFullNameFromAbbr;
exports.getUrlFullNameFromRegionId = getUrlFullNameFromRegionId;
exports.getAbbrFromRegionId = getAbbrFromRegionId;
exports.isCanadian = isCanadian;
exports.CANADA_REGION_ID = CANADA_REGION_ID;
exports.UNITED_STATES_REGION_ID = UNITED_STATES_REGION_ID;



//////////////////
// WEBPACK FOOTER
// ./~/@zillow/state-region-id-map/dist/state-region-id-map.cjs.js
// module id = 539
// module chunks = 0